<template>
    <div id="switchsite">
        <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
                <!-- @click.stop="siteId" -->
                切换站房 <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <div id="dropdown">
                <el-dropdown-menu class="add" slot="dropdown" split-button="true">
                    <div id="inp">
                        <input defaultVal="请输入关键词" id="div-inp" text="checkbox" v-model="felice" />
                        <div id="sousuo">
                            <i class="el-icon-search"></i>
                        </div>
                    </div>
                    <div class="hodern">
                        <div v-if="IsShow > 0" class="NoShow">{{ textNo }}</div>
                        <el-dropdown-item v-for="(item, index) in seat" :key="index" :command="index">
                            <div class="table-item"><img
                                    :src="item.areaImg?item.areaImg:'../../../assets/img/kongbai.png'" alt="" /></div>
                            <p>{{ item.areaName }}</p>
                        </el-dropdown-item>
                    </div>
                </el-dropdown-menu>
            </div>
        </el-dropdown>
    </div>
</template>
<script>
    import {
        chainIndex
    } from "../../../api/linkindex";
    export default {
        data() {
            return {
                apoThere: 2,
                IsShow: 0,
                areaId: 0,
                worder: "",
                getData: 1,
                felice: "",
                seat: [],
                textNo: "",
                getmqqt: "",
            };
        },
        mounted() {
            this.Soso();
            this.siteId();
        },

        watch: {
            felice(val) {
                this.felice = val;
                this.id = this.$store.state.project.currentProject.projectId;
                if (this.felice.length > 0 || this.felice != "") {
                    chainIndex.soso(this.felice, this.id).then((res) => {
                        this.seat = res.data.data.areas;
                        // console.log(this.seat);
                    });
                } else if (this.felice == "") {
                    this.id = this.$store.state.project.currentProject.projectId;
                    chainIndex.site(this.id).then((res) => {
                        this.seat = res.data.data.areas;
                    });
                }
            },
            seat(o, n) {
                if (this.seat == 0) {
                    this.textNo = "暂无数据";
                    this.IsShow = 1;
                } else {
                    this.IsShow = 0;
                    this.textNo = "";
                }
            },
        },
        created() {
            this.siteId();
        },
        beforeDestroy() {
            this.$store.commit("fomeall", null);
        },
        methods: {
            siteId() {
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.site(this.id).then((res) => {
                    this.seat = res.data.data.areas;
                    // console.log(this.seat[0].areaId);
                });
                chainIndex.loopAll(this.id).then((res) => {
                    // console.log(res.data.data, "订阅");
                    this.getmqqt = res.data.data.loops.map((item) => item.subLoopUrl);
                    // console.log(this.getmqqt);
                    this.$emit("fomeitem", this.getmqqt);
                });
            },
            //搜索
            Soso() {
                this.id = this.$store.state.project.currentProject.projectId;
                chainIndex.soso(this.felice, this.id).then((res) => {
                    if (this.felice.length > 0 || this.felice != "") {
                        this.seat = res.data.data.areas;
                    }
                });
            },

            handleCommand(command) {
                this.$store.commit("projectid", "AREA_ID");
                // console.log(this.$store.state.homeitem.pro)
                if (this.$store.state.project.currentProject.projectId == 2) {
                    if (command == 0) {
                        // console.log(`1111`)
                        this.$store.commit("setData", 1);
                        this.worder = this.seat[command];
                        this.$store.commit("mantotal", this.worder.areaName);
                        this.$store.commit("getpng", this.worder.areaImg);
                        this.areaId = this.worder.areaId;
                        //   console.log(this.worder.areaId);
                        this.$store.commit("webId", this.worder.areaId);
                        this.$store.commit("Dthere", 2);
                    } else {
                        // console.log('2222222')
                        this.$store.commit("setData", 2);
                        this.worder = this.seat[command];
                        this.$store.commit("mantotal", this.worder.areaName);
                        this.$store.commit("getpng", this.worder.areaImg);
                        this.areaId = this.worder.areaId;
                        //   console.log(this.worder.areaId,this.apoThere);
                        this.$store.commit("webId", this.worder.areaId);
                        this.$store.commit("Dthere", this.apoThere);
                    }
                } else if (this.$store.state.project.currentProject.projectId == 1) {
                    if (command == 0) {
                        this.$store.commit("setData", 1);
                        this.worder = this.seat[command];
                        this.$store.commit("mantotal", this.worder.areaName);
                        this.$store.commit("getpng", this.worder.areaImg);
                        this.areaId = this.worder.areaId;
                        //   console.log(this.worder.areaId);
                        this.$store.commit("webId", this.worder.areaId);
                        this.$store.commit("Dthere", 2);
                    } else {
                        this.$store.commit("setData", 2);
                        this.worder = this.seat[command];
                        this.$store.commit("mantotal", this.worder.areaName);
                        this.$store.commit("getpng", this.worder.areaImg);
                        this.areaId = this.worder.areaId;
                        this.$store.commit("webId", this.worder.areaId);
                        //   console.log(this.worder.areaId);
                        this.$store.commit("Dthere", this.apoThere);
                    }
                } else {
                    this.$store.commit("setData", this.getData);
                    //3D切换
                    this.$store.commit("Dthere", this.apoThere);
                    this.worder = this.seat[command];
                    this.$store.commit("mantotal", this.worder.areaName);
                    this.$store.commit("getpng", this.worder.areaImg);
                    this.areaId = this.worder.areaId;
                    this.$store.commit("webId", this.worder.areaId);
                    // console.log(this.worder.areaId);

                    // 5月17日注释关于切换切换回路卡死问题
                    chainIndex.mqqtAll(this.areaId).then((res) => {
                        // console.log(res.data.data.loop.subLoopUrl);
                        // this.getmqqt = res.data.data.loop.subLoopUrl;
                        this.$store.commit("fomeall", res.data.data.loop.subLoopUrl);
                    });
                }
            },
        },
    };
</script>
<style scoped lang="less">
    #switchsite {
        line-height: 16px;
        margin-top: 0rem;
        margin-left: 16rem;
    }

    .el-dropdown-menu {
        .w(510) !important;
        position: fixed;
        box-shadow: 10rem 10rem 30rem 10rem rgba(0, 43, 102, 0.28);
        left: 71% !important;
        top: 19% !important;
    }

    .el-dropdown-menu__item {
        display: flex !important;
        align-items: center;
        padding: 6rem 0 6rem 16rem !important;

        p {
            margin-left: 13rem;
            font-size: 16rem;
            font-weight: 400;
            color: #333333;
        }
    }

    ::v-deep .el-dropdown-link:focus {
        outline: none;
    }

    .el-dropdown-link {
        font-size: 18rem;
        cursor: pointer;
        color: #999999;
    }
    .el-dropdown-link:hover{
        color: rgba(13,148,255,0.9);
    }
    .el-icon-arrow-down {
        font-size: 12rem;
    }

    #inp {
        .w(472);
        .h(32);
        background: rgba(252, 250, 250, 0.15);
        border: 1rem solid rgba(0, 0, 0, 0.15);
        border-radius: 16rem;
        margin-left: 16rem;
        margin-top: 16rem;
        margin-bottom: 16rem;

        padding: 5rem 18rem 0rem 15rem;
        display: flex;
        justify-content: space-between;

        #div-inp {
            background: rgba(252, 250, 250, 0.15);
            color: #999999;
            .w(300);
            font-size: 16rem;
            border: none;
            outline: none;
        }
    }

    .table-item {
        .w(48);
        .h(48);

        img {
            width: 100%;
            height: 100%;
        }
    }

    #sousuo {
        .w(18);
        .h(18);
        background-color: #fff;

        .el-icon-search {
            font-size: 19rem;
        }
    }

    .NoShow {
        position: absolute;
        height: 24rem;
        color: gray;
        font-size: 16rem;
        text-align: center;
        top: 80rem;
        left: 0;
        right: 0;
        margin: auto;
    }

    .hodern {
        height: 520rem !important;
        max-height: 390rem;
        overflow-y: scroll;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .hodern::-webkit-scrollbar {
        width: 8rem;
        height: 72rem;
        background: #fff;
    }

    div::-webkit-scrollbar-track {
        width: 8rem;
        height: 72rem;
        background: #fff;
        border-radius: 4rem;
    }

    div::-webkit-scrollbar-thumb {
        width: 8rem;
        height: 72rem;
        background: #bfbfbf;
        border-radius: 10rem;
    }
</style>